/** Images for sections after the essentials block — warmed once the user starts scrolling. */
export const HOME_SCROLL_WARMUP_URLS = [
  'https://i.pinimg.com/736x/68/fe/f8/68fef885052e09d6a6446269f8b55404.jpg',
  'https://i.pinimg.com/736x/90/ba/2b/90ba2b569a6cf0d67d76a2af13f574b8.jpg',
  'https://i.pinimg.com/736x/bd/bc/89/bdbc893332d71b330f571ce631f8b766.jpg',
  'https://i.pinimg.com/736x/c0/a7/be/c0a7be3d7ee7d6ee51f7ac3880e5e5e5.jpg',
  'https://i.pinimg.com/736x/f4/8f/11/f48f118359871b62d44c0bafe9cf4961.jpg',
  'https://i.pinimg.com/736x/84/25/9e/84259e91c13c7fe79a7f980e85a6f245.jpg',
  'https://i.pinimg.com/736x/04/8b/c1/048bc1009547e451bb04b88bd867ab8a.jpg',
] as const;

let scrollWarmupDone = false;
let userLeftHero = false;

export function hasUserLeftHero(): boolean {
  return userLeftHero;
}

/** Start fetching deeper-section images once the user scrolls past the hero. */
export function warmupHomeImagesOnScroll(): void {
  if (scrollWarmupDone) return;
  scrollWarmupDone = true;
  userLeftHero = true;

  HOME_SCROLL_WARMUP_URLS.forEach((url) => {
    const img = new Image();
    img.referrerPolicy = 'no-referrer';
    img.decoding = 'async';
    img.src = url;
  });
}
